
import React, { useEffect, useState, useRef } from "react";
import API from "../Services/Auth"
import API1 from "../Services/Inventory"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import APISS from '../Services/Location'
import LocationList from "../Components/Location";
import CenterModal from "../Components/CenterSelectorModal";
import Select from "react-select";

const InventoryMapList = () => {
    const [data, setData] = useState([]);
    const [selectedInventory, setSelectedInventory] = useState("");
    const [inventoryProduct, setInventoryProduct] = useState("");
    const [centerName, setCenterName] = useState("");
    const [measurementUnit, setMeasurementUnit] = useState("");

    const [measurementUnit1, setMeasurementUnit1] = useState("");

    const [measurementUnits, setMeasurementUnits] = useState([]);
    const [price, setPrice] = useState("");
    const [uomQty, setUomQty] = useState("");

    const [openingStock, setOpeningStock] = useState("");

    const [errors, setErrors] = useState({});
    const [selectedCenter, setSelectedCenter] = useState([]);

    const [inventories, setInventories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [id, setId] = useState("");
    const [search, setSearch] = useState("")
    const perPage = 10;
    const [status, setStatus] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [locationId, setLocationId] = useState("");
    const [unitName, setUnitName] = useState("");
    const [productName, setProductName] = useState("");
    const [qty, setQty] = useState("");
    const [remark, setRemark] = useState("");
    const [date, setdate] = useState("");
    const [selectedLocation, setSelectedLocation] = useState("");
    const [location, setLocation] = useState([])

    useEffect(() => {
        bindMeasurementUnit();
        bindInventoryList();
        fetchInventoryByLocation();
        bindLocation();
    }, [currentPage, selectedCenter])

    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });
            setLocation(response?.data?.data || []);
        } catch (error) {
            console.error(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const bindInventoryList = async () => {
        try {
            const response = await API1.Get_inventory_List({ is_active: 1, limit: 0 });
            setInventories(response?.data?.data || []);
        } catch (error) {
            console.error(error);
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
        }
    };
    const fetchInventoryByLocation = async () => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payload = {
                location_ids: centerlist || null,
                inventory_product_name: search || null,
                page_number: currentPage,
                page_size: perPage,
                id: null
            };
            const response = await API1.getInventoryLocationData(payload);
            const details = response?.data;
            // console.log('details', details);
            setTotalRecords(details?.totalRecords);
            setData(details?.data)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };
    const validateFields = () => {
        const errors = {};
        const priceValue = price?.toString().trim();

        if (!priceValue) {
            errors.price = "Price is required";
        } else if (!/^\d+(\.\d{1,2})?$/.test(priceValue)) {
            errors.price = "Price must be a numeric value";
        }
        // if (!uomQty || uomQty.toString().trim() === "") {
        //     errors.uomQty = "UOM Quantity is required";
        // } else if (!/^\d+$/.test(uomQty)) {
        //     errors.uomQty = "UOM Quantity must be a numeric value";
        // }
        // if (!selectedInventory) {
        //     errors.selectedInventory = "Inventory is required";
        // }
        // const qtyValue = qty?.toString().trim();
        // if (!qtyValue) {
        //     errors.qty = "Quantity is required";
        // } else if (!/^\d+$/.test(qtyValue)) {
        //     errors.qty = "Quantity must be a number";
        // } else if (parseInt(qtyValue) <= 0) {
        //     errors.qty = "Quantity must be greater than 0";
        // }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value?.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "measurementUnit":
                setMeasurementUnit(value);
                break;
            case "openingStock":
                setOpeningStock(value);
                break;
            case "price":
                setPrice(value);
                break;
            case "uomQty":
                setUomQty(value);
                break;
            case "selectedInventory":
                setSelectedInventory(value);
                break;
            // ----------------
            case "qty":
                setQty(value);
                break;
            case "measurementUnit1":
                setMeasurementUnit1(value);
                break;
            case "remark":
                setRemark(value);
                break;
            case "date":
                setdate(value);
                break;
            default:
                break;
        }
    };

    const bindMeasurementUnit = async (type = null) => {
        let payload = {
            is_active: 1
        }
        if (type != null) {
            payload = {
                is_active: 1,
               // type
            }
        }
        const response = await API.bindMeasurementUnit(payload)
        setMeasurementUnits(response.data.data.rows)
    }

    const handleSubmit = async () => {
        if (!validateFields()) return;
        const payload = {
            inventory_product_id: id,
            location_id: parseInt(locationId),
            price: parseFloat(price)
            //inventory_id: parseInt(selectedInventory),
            // location_id: parseInt(locationId),
            // unit_id: parseInt(measurementUnit),
            // price: parseFloat(price),
            // uom_qty: parseInt(uomQty),
            // opening_stock: openingStock,
            // is_multiple: isMultiple
        };
    //  console.log('dddd', payload);

        try {
            const response = await API1.updateInventoryLocationMapping(payload);
            if (response.status === 200) {
                toast.success(response?.data?.message);
                setTimeout(() => window.location.reload(), 2000);
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                toast.error(error.response.data.message || "Bad Request");
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            else {
                toast.error("An unexpected error occurred");
            }
        }
    };

    const handleCancel = () => {
        setTimeout(() => window.location.reload());
    }
    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // bindInventoryList();
        }
    };
    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };

    const handleGetData = async (id) => {
        //console.log('ddd', id);
        try {
            setId(id);
            const payLoad = {
                location_ids: null,
                inventory_product_name: null,
                page_number: 1,
                page_size: perPage,
                id: id
            }
            const response = await API1.getInventoryLocationData(payLoad);
            const fetchedData = response?.data?.data?.[0];
            if (fetchedData) {
                setId(fetchedData?.id);
                setSelectedInventory(fetchedData?.inventory_id);
                setInventoryProduct(fetchedData?.inventory_product);
                setCenterName(fetchedData?.center_name);
                setLocationId(fetchedData?.location_id);
                setSelectedLocation(fetchedData?.location_id);
                setMeasurementUnit(fetchedData?.unit_id);
                setOpeningStock(fetchedData?.opening_stock);
                setPrice(fetchedData?.price);
                setUomQty(fetchedData?.uom_qty);
                setStatus(fetchedData?.is_active);
                setCreatedAt(fetchedData?.createdAt);
                setUnitName(fetchedData?.unit)

            }
            else {
                toast.error("Failed to fetch designation details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const handleStatusToggle = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API1.Update_Status({inventory_product_id:id});
            if (response.status === 200) {
                setData((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(response.data.message);
                fetchInventoryByLocation();
            } else {
                toast.error("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found.');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };

    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;
        if (fieldName === "search") {
            setSearch(value);
            if (value.trim() === "") {
                setCurrentPage(1);
                fetchInventoryByLocation(1);
            }
        }
    };
    const handleSearch = () => {
        setCurrentPage(1);
        fetchInventoryByLocation(1);
    };

    const locationOptions = location.map((item) => ({
        value: item.id,
        label: item.name,
    }));


    const handleSubmitAddStock = async () => {
        if (!validateFields()) return;
        try {
            const payload = {
                location_id: parseInt(selectedLocation),
                quantity: parseInt(qty),
                unit: parseInt(measurementUnit),
                remarks: remark
            };
            const response = await API1.addStock(id, payload);
            if (response.status === 200) {
                toast.success(response.data.message);
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response.data.message || "Something went wrong!");
            }
            setQty("");
            setRemark("");
            setdate("");
            setMeasurementUnit("");
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            if (error.response) {
                console.error("Server Error:", error.response.data);
                toast.error(
                    error.response.data.message || "An error occurred while submitting data."
                );
            } else if (error.request) {
                console.error("Network Error:", error.request);
                toast.error("Network error: Please check your internet connection.");
            } else {
                console.error("Error:", error.message);
                toast.error("An unexpected error occurred.");
            }
        }
    };

    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Total Ingredient</h4>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3 align-items-end">
                            <div className="col-md-4">
                                <CenterModal onSelectCenter={handleSelectedCenter} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">
                                    <b>Search by Name</b>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by Name"
                                    value={search}
                                    onChange={(e) => handleFieldChange1(e, "search")}
                                />
                            </div>

                            <div className="col-md-3">
                                <button
                                    onClick={handleSearch}
                                    className="btn btn-success"
                                    type="button"
                                >
                                    Search
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Action</th>
                                        <th>Inventory Name</th>
                                        <th>Center Name</th>
                                        <th>Measurement Unit</th>
                                        <th><span className="mdi mdi-currency-rupee"></span> Price</th>
                                        <th>Uom Qty</th>
                                        <th>Opening Stock</th>
                                        <th>Current Stock</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModalEdit"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">

                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => handleStatusToggle(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activated" : "Activate"}
                                                                    </button>

                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-success btn-sm"
                                                    onClick={() => handleGetData(item.id)}
                                                    data-bs-toggle="modal" data-bs-target="#staticBackdrop">Add Stock</button>{' '}</td>
                                            <td>{item.inventory_product}</td>
                                            <td>{item.center_name}</td>
                                            <td>{item.unit}</td>

                                            <td>{item?.price}</td>
                                            <td>{item.uom_qty}</td>
                                            <td>{item?.opening_stock}</td>
                                            <td>{item?.current_stock}</td>
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className="modal" id="myModalView">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Map Inventory Details</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            <div className="modal-body">
                                <table className="table table-bordered border-secondary">
                                    <tbody>
                                        <tr>
                                            <th>Inventory Name</th>
                                            <td>{inventoryProduct}</td>

                                            <th>Center Name</th>
                                            <td>{centerName}</td>
                                        </tr>

                                        <tr>
                                            <th>Measurement Unit</th>
                                            <td>{unitName}</td>

                                            <th>Opening Stock</th>
                                            <td>{openingStock}</td>
                                        </tr>
                                        <tr>
                                            <th><span className="mdi mdi-currency-rupee"></span> Price</th>
                                            <td>{price}</td>
                                            <th>UOM Quantity</th>
                                            <td>{uomQty}</td>

                                        </tr>
                                        <tr>
                                            <th>Status</th>
                                            <td>{status ? "Active" : "De-Activated"}</td>

                                            <th>Created Date</th>
                                            <td>{createdAt ? moment(createdAt).format("DD-MM-YYYY") : "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="modal" id="myModalEdit">
                    <div className="modal-dialog  modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Edit Ingredient</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <LocationList
                                            selectedLocation={locationId}
                                            label="Center"
                                            isRequired={false}
                                            disabled={true}
                                            setSelectedLocation={(location) => {
                                                setLocationId(location);
                                                if (location.trim()) {
                                                    setErrors((prevErrors) => {
                                                        const updatedErrors = { ...prevErrors };
                                                        delete updatedErrors.locationId;
                                                        return updatedErrors;
                                                    });
                                                }
                                            }}
                                        />
                                        {errors?.locationId && <span className="text-danger">{errors.locationId}</span>}
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="ddInventory" className="form-label">
                                                Inventory Name <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select
                                                className={`form-select ${errors.selectedInventory ? "is-invalid" : ""}`}
                                                id="ddInventory"
                                                value={selectedInventory}
                                                disabled={true}
                                                onChange={(e) => handleFieldChange(e, "selectedInventory")}
                                            >
                                                <option value="">Select Inventory</option>
                                                {inventories.map((inv) => (
                                                    <option key={inv.id} value={inv.id}>
                                                        {inv.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.selectedInventory && (
                                                <div className="invalid-feedback">{errors.selectedInventory}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="ddMeasurementUnit" className="form-label">
                                                Measurement Unit <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select
                                                className={`form-select ${errors.measurementUnit ? "is-invalid" : ""}`}
                                                id="ddMeasurementUnit"
                                                value={measurementUnit}
                                                onChange={(e) => handleFieldChange(e, "measurementUnit")}
                                               // disabled={true}
                                            >
                                                <option value="">Select Unit </option>
                                                {measurementUnits.map((unit) => (
                                                    <option key={unit.id} value={unit.id}>
                                                        {unit.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.measurementUnit && (
                                                <div className="invalid-feedback">{errors.measurementUnit}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="txtstock" className="form-label">
                                                Opening Stock <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.openingStock ? "is-invalid" : ""}`}
                                                id="txtstock"
                                                placeholder="Stock"
                                                value={openingStock}
                                                onChange={(e) => handleFieldChange(e, "openingStock")}
                                                disabled={true}
                                            />
                                            {errors.openingStock && (
                                                <div className="invalid-feedback">{errors.openingStock}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="txtPrice" className="form-label">
                                             <span className="mdi mdi-currency-rupee"></span> Price <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.price ? "is-invalid" : ""}`}
                                                id="txtPrice"
                                                placeholder="Price"
                                                value={price}
                                                // disabled={true}
                                                onChange={(e) => handleFieldChange(e, "price")}
                                            />
                                            {errors.price && <div className="invalid-feedback">{errors.price}</div>}
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="txtUOMQty" className="form-label">
                                                UOM Quantity <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.uomQty ? "is-invalid" : ""}`}
                                                id="txtUOMQty"
                                                placeholder="UOM Quantity"
                                                value={uomQty}
                                                //disabled={true}
                                                onChange={(e) => handleFieldChange(e, "uomQty")}
                                            />
                                            {errors.uomQty && <div className="invalid-feedback">{errors.uomQty}</div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <button
                                        type="button"
                                        onClick={handleSubmit}
                                        className="btn btn-primary me-2"
                                    >
                                        Update
                                    </button>
                                    <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                </div>
                            </div>
                            <div className="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section>
                <div
                    className="modal fade"
                    id="staticBackdrop"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered modal-lg"
                        style={{ width: "900px" }}
                    >
                        <div className="modal-content" style={{ backgroundColor: "#fff" }}>
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <table
                                    className="table table-bordered text-center"
                                    style={{ tableLayout: "fixed", width: "100%" }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "33.33%" }}>Product Name</th>
                                            <th style={{ width: "33.33%" }}>Qty <span style={{ color: "red" }}>*</span></th>
                                            <th style={{ width: "33.33%" }}>Unit <span style={{ color: "red" }}>*</span></th>
                                            <th style={{ width: "33.33%" }}>Center <span style={{ color: "red" }}>*</span></th>
                                            <th style={{ width: "33.33%" }}>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{inventoryProduct}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.qty ? "is-invalid" : ""}`}
                                                    id="txtqty"
                                                    placeholder="Enter Quantity"
                                                    value={qty}
                                                    onChange={(e) => handleFieldChange(e, "qty")}
                                                />
                                                {errors.qty && <div className="invalid-feedback">{errors.qty}</div>}
                                            </td>
                                            <td>
                                                {/* {unitName} */}
                                                <select
                                                    className={`form-select ${errors.measurementUnit ? "is-invalid" : ""
                                                        }`}
                                                    id="ddMeasurementUnit"
                                                    disabled={true}
                                                    value={measurementUnit}
                                                    onChange={(e) => handleFieldChange(e, "measurementUnit")}
                                                >
                                                    <option value="">Select Unit</option>
                                                    {measurementUnits && measurementUnits.map((unit) => (
                                                        <option key={unit.id} value={unit.id}>
                                                            {unit.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.measurementUnit && (
                                                    <div className="invalid-feedback">{errors.measurementUnit}</div>
                                                )}
                                            </td>

                                            <td>
                                                <Select
                                                    id="ddSalesType"
                                                    options={locationOptions}
                                                    placeholder="Select Center"
                                                    isSearchable={true}
                                                    disabled={true}
                                                    value={locationOptions.find(
                                                        (opt) => opt.value === selectedLocation
                                                    )}
                                                    onChange={(selectedOption) =>
                                                        setSelectedLocation(selectedOption?.value)
                                                    }
                                                />

                                                {/* <input
                                                    type="date"
                                                    className={`form-control ${errors.date ? "is-invalid" : ""}`}
                                                    id="txtdate"
                                                    value={date}
                                                    max={new Date().toISOString().split("T")[0]}
                                                    onChange={(e) => handleFieldChange(e, "date")}
                                                />
                                                {errors.date && <div className="invalid-feedback">{errors.date}</div>} */}
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.remark ? "is-invalid" : ""}`}
                                                    id="txtremarks"
                                                    placeholder="Enter Remarks"
                                                    value={remark}
                                                    onChange={(e) => handleFieldChange(e, "remark")}
                                                />
                                                {errors.remark && (
                                                    <div className="invalid-feedback">{errors.remark}</div>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                //  onClick={handleClose}
                                >
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleSubmitAddStock}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div >

    );
};

export default InventoryMapList;

